module.exports = __webpack_public_path__ + "static/media/check_with_bg.1437fe1d.svg";